import PropTypes from 'prop-types'
import HexaV2SideBarMenu from '../HexaV2SidebarMenu'

import * as S from './styles'

const PageLayout = ({ children }) => {
  return (
    <S.Layout>
      <HexaV2SideBarMenu />
      <S.LayoutMain>
        <S.LayoutContent>{children}</S.LayoutContent>
      </S.LayoutMain>
    </S.Layout>
  )
}

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PageLayout
